import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-location-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class LocationPaymentMethodsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
